module.exports = __webpack_public_path__ + "packs/media/images/Registration_Step_9-d8201d04316cd698c2b43fcbbe8351a4.jpg";